import type {
  DatasetsTableFilter,
  PipesTableFilter,
  SystemsTableFilter,
} from '../types/pipesList.types';

export const getDefaultFilterFn =
  (filters: PipesTableFilter | SystemsTableFilter | DatasetsTableFilter) =>
  (filter: 'user' | 'system') => ({
    ...filters,
    origin: {
      ...filters.origin,
      selected: [filter],
    },
  });
